import { css } from 'styled-components/macro';

const base = css`
  :root {
    scroll-behavior: smooth;
  }

  html {
    box-sizing: border-box;
  }

  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }

  body {
    margin: 0;
    background-color: #e8ebed;
  }

  /**
 * Add the correct display in browsers that don't support HTML5 elements by default.
 */
  article,
  aside,
  footer,
  header,
  nav,
  figcaption,
  figure,
  main,
  section {
    display: block;
  }

  strong {
    font-weight: 600;
  }

  ul,
  dl {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  dt,
  dd {
    margin: 0;
    padding: 0;
  }

  img {
    display: block;
    max-width: 100%;
  }

  a {
    text-decoration: none;
  }

  button {
    appearance: none;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
    background: none;
    border: 0;
  }

  a:focus,
  button:focus,
  summary:focus,
  input[type='radio']:focus + label {
    outline: none;
    box-shadow: none;
  }

  pre {
    font-family: Menlo, Consolas, monospace;
    white-space: normal;
  }

  details {
    white-space: pre-wrap;
  }

  /** IE11 by default shifts button children when focussing, See: https://stackoverflow.com/questions/10305658/prevent-button-from-shifting-during-click-in-ie  */
  button > * {
    position: relative;
  }

  #root {
    display: flex;
  }

  #modal {
    position: relative;
    /** To prevent overlapping Header/TopBar and modals */
    z-index: 10001;
  }

  #territory-tooltip {
    pointer-events: none;
  }

  .modal-open {
    overflow: hidden;
  }

  /** Add overflow hidden to both the HTML and BODY element otherwise you will still be able to scroll on iOS */
  .block-body-scroll {
    &,
    body {
      overflow: hidden;
      position: relative;
      height: 100%;
    }
  }

  /* NOTE: min-width should equal components/notifications/Events/index => <Absolute /> */
  @media only screen and (min-width: 50em) {
    .block-body-scroll {
      &,
      body {
        overflow: visible;
        position: static;
        height: auto;
      }
    }
  }

  #onetrust-consent-sdk {
    #onetrust-button-group {
      #onetrust-pc-btn-handler,
      button {
        background-color: rgb(11, 214, 167) !important;
      }
    }

    #onetrust-banner-sdk {
      .ot-sdk-row {
        display: flex !important;
        justify-content: space-between !important;
        align-items: center !important;
        #onetrust-group-container {
          flex-grow: 1 !important;
        }
        #onetrust-button-group-parent {
          transform: none !important;
          position: relative !important;
          left: auto !important;
          margin: 0 !important;
          top: 0 !important;
        }

        @media only screen and (max-width: 1024px) {
          flex-direction: column;
        }
      }

      a[href] {
        color: rgb(11, 214, 167) !important;
      }
    }

    #onetrust-policy-text {
      font-family: 'Proxima Nova', sans-serif !important;
    }
  }
`;

export default base;
